'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentVisaIcon = function (_React$Component) {
    _inherits(PaymentVisaIcon, _React$Component);

    function PaymentVisaIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PaymentVisaIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentVisaIcon.__proto__ || Object.getPrototypeOf(PaymentVisaIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { id: 'amex', xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 48' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: width, height: height, fill: 'transparent' }),
                _react2.default.createElement('path', { id: 'Path_464', 'data-name': 'Path 464', d: 'M33.047-15.258l-.211-.914-.211.7-.141.352-1.125,3.023h2.32Q33.4-13.641,33.047-15.258ZM40.5-25.875a3.255,3.255,0,0,0-.984-2.391,3.255,3.255,0,0,0-2.391-.984H3.375a3.255,3.255,0,0,0-2.391.984A3.255,3.255,0,0,0,0-25.875v24.75A3.255,3.255,0,0,0,.984,1.266a3.255,3.255,0,0,0,2.391.984h33.75a3.255,3.255,0,0,0,2.391-.984A3.255,3.255,0,0,0,40.5-1.125ZM10.758-8.227H7.734L5.2-17.719a11.813,11.813,0,0,0-2.953-1.2l.07-.211h4.5q1.125.07,1.336.914l1.266,6.539,2.742-7.453h3.023Zm6.609,0H14.555l1.758-10.9h2.812Zm9.844-3.516A3.21,3.21,0,0,1,25.84-9.035a5.8,5.8,0,0,1-3.551,1.02,8.2,8.2,0,0,1-3.164-.633l.422-2.461.352.211a4.92,4.92,0,0,0,1.266.457,7.122,7.122,0,0,0,1.3.105,2.656,2.656,0,0,0,1.266-.281.857.857,0,0,0,.527-.773.9.9,0,0,0-.352-.668,4.549,4.549,0,0,0-1.125-.668q-2.531-1.266-2.5-2.918a3.3,3.3,0,0,1,1.371-2.672,5.522,5.522,0,0,1,3.445-1.02,6.583,6.583,0,0,1,2.531.492l-.422,2.32-.281-.07a4.067,4.067,0,0,0-2.109-.422,1.969,1.969,0,0,0-1.16.281.907.907,0,0,0-.422.633.7.7,0,0,0,.352.633,9.349,9.349,0,0,0,1.23.7Q27.211-13.57,27.211-11.742Zm9.914,3.516h-2.6l-.352-1.617H30.516l-.562,1.617H27l4.219-9.984a1.419,1.419,0,0,1,1.477-.914h2.18Z', transform: 'translate(4 37.25)', fill: '#777' })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PaymentVisaIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 48;
            return _react2.default.createElement(
                _layout2.default,
                { size: size },
                this.getIcon(size, size, this.props.primary)
            );
        }
    }]);

    return PaymentVisaIcon;
}(_react2.default.Component);

exports.default = PaymentVisaIcon;